import MARKER_COLORS from './marker-colors';

export default [
  {
    label: 'Has Fuel & Power',
    color: MARKER_COLORS.GREEN,
  },
  {
    label: 'Has No Power',
    color: MARKER_COLORS.BLACK,
  },
  {
    label: 'Limited Fuel Options',
    color: MARKER_COLORS.YELLOW,
  },
  {
    label: 'Has No Fuel & Power',
    color: MARKER_COLORS.RED,
  },
];
